import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./cyo.css";

const Alcohol = [
  { name: "Vodka", price: 12 },
  { name: "Whiskey", price: 12 },
  { name: "Tequila", price: 12 },
  { name: "Rum", price: 12 },
  { name: "Champagne", price: 12 },
];
const Juices = [
  { name: "Orange" },
  { name: "Cranberry" },
  { name: "Tomato" },
  { name: "Lemon" },
  { name: "Lime" },
];
const Ingredients = [
  { name: "Ginger" },
  { name: "Mint" },
  { name: "Cinnamon" },
];
const Syrup = [
  { name: "Blue Curacao" },
  { name: "Pure Sugar Cane" },
  { name: "Grenadine" },
  { name: "Passion Fruit" },
  { name: "Strawberry " },
  { name: "Sweetner Sugar Free" },
  { name: "Vanilla" },
  { name: "Mojito Mint" },
];
const Sodas = [
  { name: "Soda water" },
  { name: "Club Soda" },
  { name: "Tonic Water" },
  { name: "Ginger Ale" },
  { name: "Ginger Beer" },
  { name: "Lemon-Lime Soda" },
  { name: "Cola" },
  { name: "Root Beer" },
];

const Options = [Alcohol, Juices, Ingredients, Syrup, Sodas];

function CreateYourOwn(props) {
  let history = useHistory();
  const [item, setItem] = useState({
    image: "https://i.ibb.co/kDjz6vr/coctail.jpg",
    name: "",
    price: 12,
    description: "",
    quantity: 1,
  });

  const handleChange = (selectedItem) => (e) => {
    let copyItem = { ...item };
    if (e.target.checked) {
      copyItem.name += selectedItem.name + ", ";
    } else {
      copyItem.name = copyItem.name.replace(selectedItem.name + ", ", "");
    }

    setItem(copyItem);
    // setItem({...item, selectedItem})
  };

  const showAlcohol = () => {
    return Alcohol.map((eachItem) => {
      return (
        <div key={eachItem.name}>
          <input
            type="checkbox"
            class="btn-check"
            name="btnradio"
            id={eachItem.name}
            autocomplete="off"
            onChange={handleChange(eachItem)}
          />
          <label className="btn btn-outline-primary" for={eachItem.name}>
            {eachItem.name}
          </label>
        </div>
      );
    });
  };

  const showJuices = () => {
    return Juices.map((eachItem) => {
      return (
        <div key={eachItem.name}>
          <input
            type="checkbox"
            class="btn-check"
            name="btnradio"
            id={eachItem.name}
            autocomplete="off"
            onChange={handleChange(eachItem)}
          />
          <label className="btn btn-outline-primary" for={eachItem.name}>
            {eachItem.name}
          </label>
        </div>
      );
    });
  };

  const showIngredients = () => {
    return Ingredients.map((eachItem) => {
      return (
        <div key={eachItem.name}>
          <input
            type="checkbox"
            class="btn-check"
            name="btnradio"
            id={eachItem.name}
            autocomplete="off"
            onChange={handleChange(eachItem)}
          />
          <label className="btn btn-outline-primary" for={eachItem.name}>
            {eachItem.name}
          </label>
        </div>
      );
    });
  };

  const showSyrup = () => {
    return Syrup.map((eachItem) => {
      return (
        <div key={eachItem.name}>
          <input
            type="checkbox"
            class="btn-check"
            name="btnradio"
            id={eachItem.name}
            autocomplete="off"
            onChange={handleChange(eachItem)}
          />
          <label className="btn btn-outline-primary" for={eachItem.name}>
            {eachItem.name}
          </label>
        </div>
      );
    });
  };

  const showSodas = () => {
    return Sodas.map((eachItem) => {
      return (
        <div key={eachItem.name}>
          <input
            type="checkbox"
            class="btn-check"
            name="btnradio"
            id={eachItem.name}
            autocomplete="off"
            onChange={handleChange(eachItem)}
          />
          <label className="btn btn-outline-primary" for={eachItem.name}>
            {eachItem.name}
          </label>
        </div>
      );
    });
  };
  // const showOptions = () => {
  //   return Options.map((eachOption) => {
  //     let subOptions = eachOption.map((eachItem) => (
  //       <>
  //         <input
  //           type="checkbox"
  //           class="btn-check"
  //           name="btnradio"
  //           id={eachItem.name}
  //           autocomplete="off"
  //           onChange={handleChange(eachItem)}
  //         />
  //         <label className="btn btn-outline-primary" for={eachItem.name}>
  //           {eachItem.name}
  //         </label>
  //       </>
  //     ));
  //     return <ul>{subOptions}</ul>;
  //   });
  // };
  return (
    <div className="container-fluid">
      <img
        className="d-block w-100"
        src="https://cloudfront-us-east-1.images.arcpublishing.com/advancelocal/NCOISQHM5RF37L34DSZYKXE23Y.JPG"
      />
      You've ordered: {item.name}
      <div className="container-fluid">
        <div className="ingredients container-fluid">
          <h5>
            <strong style={{ padding: "10px" }}>Select Your Alcohol: </strong>
          </h5>
          {showAlcohol()}
        </div>
        <div className="ingredients container-fluid">
          <div>
            <h5>
              <strong style={{ padding: "10px" }}>Select Your Juices: </strong>
            </h5>
          </div>
          {showJuices()}
        </div>
        <div className="ingredients container-fluid">
          <div>
            <h5>
              <strong style={{ padding: "10px" }}>
                Select Your Ingredients:
              </strong>
            </h5>
          </div>
          {showIngredients()}
        </div>
        <div className="ingredients container-fluid">
          <div>
            <h5>
              <strong style={{ padding: "10px" }}>Select Your Syrups: </strong>
            </h5>
          </div>
          {showSyrup()}
        </div>
        <div className="ingredients container-fluid">
          <div>
            <h5>
              <strong style={{ padding: "10px" }}>Select Your Sodas: </strong>
            </h5>
          </div>
          {showSodas()}
        </div>
        {/* {showOptions()} */}
        {/* Special Request Field */}
        <div className="cyo_addToCart_Btn_container">
          <div className="mb-3">
            <label for="exampleFormControlTextarea1" className="form-label">
              <h6>Special Requests :</h6>
            </label>
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              cols="50"
              onChange={(e) => {
                item["description"] = e.target.value;
                setItem(item);
              }}
            ></textarea>
          </div>
          <button
            className="btn btn-primary"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight"
            onClick={() => {
              let newCart = { ...props.cart };
              let id = Math.random();
              item.id = id;
              newCart[id] = item;
              console.log(newCart);
              props.setCart(newCart);
            }}
          >
            Add to Cart
          </button>
          <div
            class="offcanvas offcanvas-end"
            tabindex="-1"
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
          >
            <div class="offcanvas-header">
              <h5 id="offcanvasRightLabel">Offcanvas right</h5>
              <button
                type="button"
                class="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body">{item.name}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateYourOwn;
